import {useLayoutEffect, useState} from 'react';
import {useTransformContext} from 'react-zoom-pan-pinch';

export const useTransformScale = () => {
  const context = useTransformContext();
  const [scale, setScale] = useState(context.transformState.scale);

  useLayoutEffect(() => {
    setScale(context.transformState.scale);

    return context.onChange(({state}) => setScale(state.scale));
  }, [context]);

  return scale;
};
